import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { routeAllowedForProfile } from "../utils/profileAccess";

interface IPrivateRouteProps {}

const PrivateRoute: React.FC<IPrivateRouteProps> = () => {
  const { authenticated, loadingSession, user } = useAuth();
  const location = useLocation();

  if (loadingSession) {
    return <></>;
  }

  if (!authenticated) {
    return <Navigate to="/p/login" />;
  }

  if (!routeAllowedForProfile(location.pathname, user?.profile)) {
    return <Navigate to="/weighingRail" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
